import { Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Hero from "./components/Hero"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Thanks from "./components/Thanks";
// import ServiceApi from "./components/ServiceApi";
function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/Hero" element={<Hero />} />
      {/* <Route path="/service-api" element={<ServiceApi />} /> */}
      <Route path="/thanks" element={<Thanks />}></Route>
    </Routes>
    <ToastContainer />
    </>
    
  );
}

export default App;
